import React from 'react'
import "../styles/ActorCard.css"

const ActorCard = ({image_url}) => {

  return (
    <div className="actor-image-container">
        <img src={image_url}/>
    </div>
  )
}

export default ActorCard